enum RPC_COMMANDS {
	CreateVisualization = 'volume.create',
	ResetCamera = 'reset',
	ResetColorAndOpacity = 'volume.reset.color.and.opacity',
	ResetStructures = 'volume.reset.structures',
	MouseZoomWheel = 'viewport.mouse.zoom.wheel',
	Preset = 'volume.preset',
	Length = 'volume.length',
	Rotate = 'volume.rotate',
	Angle = 'volume.angle',
	DeleteAnnotation = 'volume.delete',
	Pan = 'volume.pan',
	Crop = 'volume.crop',
	CropFreehand = 'volume.crop.freehand',
	ViewPlane = 'volume.view.plane',
	ViewRevert = 'volume.revert.view.plane',
	// window level
	Shift = 'volume.shift',
	RemoveBed = 'volume.remove.bed',
	Zoom = 'volume.zoom',
	VolumeStatus = 'volume.status',
	SwitchSeries = 'volume.recreate',
	Flythrough = 'endo.flythrough',

	/// MPR commands
	MprDefault = 'mpr.default', /// Default MPR là mode crosshair mặc định
	MprPan = 'mpr.pan',
	MprZoom = 'mpr.zoom',
	MprWindowLevel = 'mpr.wwwl', /// command set theo giá trị
	MprWindowLevelInteraction = 'mpr.adjust.wwwl', /// command chuyển mode interaction
	SetSlab = 'mpr.slab',
	ResetMpr = 'mpr.reset',
	Show3D = 'volume.toggle.segmentation',
}
enum VIEW_OPTIONS {
	ANTERIOR = 'ANTERIOR',
	SUPERIOR = 'SUPERIOR',
	INFERIOR = 'INFERIOR',
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
	POSTERIOR = 'POSTERIOR',
}

export { RPC_COMMANDS, VIEW_OPTIONS };
